export * from "./lib";

import * as MXGRAPH_ALL from "./lib";

export { MXGRAPH_ALL };